exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2UkqHwF61nKojO{padding:8px 4px 4px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Noto Sans,Ubuntu,Droid Sans,Helvetica Neue,sans-serif}._2UkqHwF61nKojO hr{margin:16px 0}._2UkqHwF61nKojO .LFVXXJJEslRciE{color:#5e6c84;margin-left:4px}._2UkqHwF61nKojO ._3JhrfpJwNM_bY8{margin-bottom:3px}._2UkqHwF61nKojO ._2w7RtiSh-zHu5v{color:#5e6c84}._2UkqHwF61nKojO ._2w7RtiSh-zHu5v:hover{color:#172b4d}._2UkqHwF61nKojO ._2XvllcabgW_r1O{background-color:#f7f0fa;margin-bottom:8px;min-height:123px;padding-top:16px}._2UkqHwF61nKojO ._2XvllcabgW_r1O img{width:190px;margin-bottom:-20px}", ""]);

// exports
exports.locals = {
	"popoverContent": "_2UkqHwF61nKojO",
	"visibilityText": "LFVXXJJEslRciE",
	"visibilityIcon": "_3JhrfpJwNM_bY8",
	"learnMoreLink": "_2w7RtiSh-zHu5v",
	"imgContainer": "_2XvllcabgW_r1O"
};